import React from "react";
import './../dtr.scss';
import axios from "../../../api/axios";
import { useQuery } from "@tanstack/react-query";
import Error from "../../error/Error";

const Record = () => {
    const search = window.location.search;
    const param = new URLSearchParams(search);
    const token = param.get('token');

    const { data: timesheet, isLoading: isLoadingTimesheet, error } = useQuery({
        queryKey: ['timesheet'],
        queryFn: async () => {
            const res = await axios.get('dtr/timesheets', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            return res.data.response;
        },
        enabled: !!token,
        retry: false
    });

    return (
        <div className="dtr record">
            {
                error
                    ? (
                        <Error message={error.response?.data.response} />
                    ) : (
                        <div className="timesheet">
                            <div className="content">
                                <table className={isLoadingTimesheet ? 'loading' : ''}>
                                    <thead>
                                        <tr>
                                            <th colSpan="12">TIMESHEET</th>
                                        </tr>
                                        <tr>
                                            <td colSpan="12"></td>
                                        </tr>
                                        <tr>
                                            <th colSpan="3">PayPeriod</th>
                                            <th colSpan="3">{timesheet?.header?.payperiod}</th>
                                            <th colSpan="3">Payroll Date</th>
                                            <th colSpan="3">{timesheet?.header?.payrolldate}</th>
                                        </tr>
                                        <tr>
                                            <th colSpan="3">Employee ID</th>
                                            <th colSpan="3">{timesheet?.header?.employeeid}</th>
                                            <th colSpan="3">Company</th>
                                            <th colSpan="3">OCVI-MSW</th>
                                        </tr>
                                        <tr>
                                            <th colSpan="3" rowSpan="2">Employee Name</th>
                                            <th colSpan="3" rowSpan="2">{timesheet?.header?.name}</th>
                                            <th colSpan="3">Department</th>
                                            <th colSpan="3">{timesheet?.header?.department}</th>
                                        </tr>
                                        <tr>
                                            <th colSpan="3">Unit / Group</th>
                                            <th colSpan="3">Operations</th>
                                        </tr>
                                        <tr>
                                            <th>Day</th>
                                            <th>Shift Schedule</th>
                                            <th>Time In</th>
                                            <th>Time Out</th>
                                            <th>Start Break</th>
                                            <th>Stop Break</th>
                                            <th>Total Break</th>
                                            <th>Total Hours</th>
                                            <th>Undertime</th>
                                            <th>Overbreak</th>
                                            <th>ND</th>
                                            <th>OT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingTimesheet ? (
                                            [...Array(10)].map((_, i) => (
                                                <tr key={i}>
                                                    {Array.from({ length: 12 }).map((_, j) => <td key={j}><span></span></td>)}
                                                </tr>
                                            ))
                                        ) : (
                                            timesheet?.dtr.map((item) => (
                                                <tr key={item.id} className={item.class}>
                                                    <td><span>{item.day}</span></td>
                                                    <td><span>{item.shift}</span></td>
                                                    <td><span>{item.timein}</span></td>
                                                    <td><span>{item.timeout}</span></td>
                                                    <td><span>{item.startbreak}</span></td>
                                                    <td><span>{item.stopbreak}</span></td>
                                                    <td><span>{item.totalbreak}</span></td>
                                                    <td><span>{item.totalhours}</span></td>
                                                    <td><span>{item.undertime}</span></td>
                                                    <td><span>{item.overbreak}</span></td>
                                                    <td><span>{item.nd}</span></td>
                                                    <td><span>{item.ot}</span></td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>   

                                <p style={{ marginTop: '1rem', fontSize: '.9rem' }}>Note: Flashing red background indicates that the time period has pending adjustment request.</p>           
                            </div>
                        </div>
                    )
            }   
        </div>  
    );
};

export default Record;
